export default __webpack_public_path__ + "static/media/StarMarket.00027a2f.png";